import { net_common, net_filemanage } from "@/api/http";
export const API_Signout = (...params) =>
  net_common.post("/api/STDSCM04C00/Signout", ...params);

export const API_BopSignout = (...params) =>
  net_common.post("/api/STDSCM04C00/BopSignout", ...params);

export const API_Header = (...params) =>
  net_common.post("/api/STDSCM04C00/Header", ...params);

export const API_BopHeader = (...params) =>
  net_common.post("/api/STDSCM04C00/BopHeader", ...params);

export const API_DocumentManageLock = (...params) =>
  net_common.post("/api/STDSCM04C00/DocumentManageLock", ...params);

export const API_DocumentManageUnlock = (...params) =>
  net_common.post("/api/STDSCM04C00/DocumentManageUnlock", ...params);

export const API_SetFilter = (...params) =>
  net_common.post("/api/STDSCM04C00/SetFilter", ...params);

export const API_BopDataLock = (...params) =>
  net_common.post("/api/STDSCM04C00/BopDataLock", ...params);

export const API_BopDataUnlock = (...params) =>
  net_common.post("/api/STDSCM04C00/BopDataUnlock", ...params);

export const API_BopEmpLock = (...params) =>
  net_common.post("/api/STDSCM04C00/BopEmpLock", ...params);

export const API_BopEmpUnlock = (...params) =>
  net_common.post("/api/STDSCM04C00/BopEmpUnlock", ...params);

export const API_DocumentManageUnlockForBopUser = (...params) =>
  net_common.post("/api/STDSCM04C00/DocumentManageUnlockForBopUser", ...params);

export const API_BopDeptUnlock = (...params) =>
  net_common.post("/api/STDSCM04C00/BopDeptUnlock", ...params);

export const API_BopDeptLock = (...params) =>
  net_common.post("/api/STDSCM04C00/BopDeptLock", ...params);

export const API_COMMON_GetFileData = (...params) =>
  net_common.post("/api/STDSCM04C00/GetFileData", ...params);

export const API_FILEMANAGE_GetFileData = (...params) =>
  net_filemanage.post("/api/STDSCM04C00/GetFileData", ...params);
  
export const API_COLLECTION_GetFileData = (...params) =>
  net_collection.post("/api/STDSCM04C00/GetFileData", ...params);

export const API_SearchAddressList_NetCommon = (...params) =>
  net_common.post("/api/STDSCM04C00/SearchAddressList", ...params);

export const API_SearchAddressList = (...params) =>
  net_collection.post("/api/STDSCM04C00/SearchAddressList", ...params);

export const API_GetCityList = (...params) =>
  net_collection.post("/api/STDSCM04C00/GetCityList", ...params);

export const API_GetAuthorityInfoList_NetCommon = (...params) =>
  net_common.post("/api/STDSCM04C00/GetAuthorityInfoList", ...params);

export const API_GetAuthorityInfoList = (...params) =>
  net_collection.post("/api/STDSCM04C00/GetAuthorityInfoList", ...params);
export const API_GetString = (...params) =>
  net_common.post("/api/STDSCM04C00/GetString", ...params);
export const API_ProcessingInfoInitClear = (...params) =>
  net_common.post("/api/STDSCM04C00/ProcessingInfoInitClear", ...params);